module.exports = __webpack_public_path__ + "img/cocos_4.ff20d904.jpg";